import React from 'react';

export const SettingsIcon = props =>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.031"
    height="16"
    viewBox="0 0 16.031 16"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path
      d="M527.949,694.112a0.52,0.52,0,0,0-.514-0.394,1.767,1.767,0,0,1-1.209-3.075,0.444,0.444,0,0,0,.049-0.6,7.957,7.957,0,0,0-1.268-1.28,0.446,0.446,0,0,0-.608.049,1.842,1.842,0,0,1-2,.448,1.775,1.775,0,0,1-1.08-1.736,0.445,0.445,0,0,0-.393-0.468,8.025,8.025,0,0,0-1.8,0,0.446,0.446,0,0,0-.4.458,1.779,1.779,0,0,1-1.1,1.707,1.849,1.849,0,0,1-1.981-.451,0.447,0.447,0,0,0-.6-0.051,7.915,7.915,0,0,0-1.294,1.28,0.444,0.444,0,0,0,.048.608,1.774,1.774,0,0,1,.447,2,1.85,1.85,0,0,1-1.741,1.082,0.435,0.435,0,0,0-.462.392,8.026,8.026,0,0,0,0,1.82,0.529,0.529,0,0,0,.524.393,1.753,1.753,0,0,1,1.646,1.1,1.78,1.78,0,0,1-.447,1.979,0.444,0.444,0,0,0-.049.6,7.908,7.908,0,0,0,1.266,1.281,0.445,0.445,0,0,0,.609-0.049,1.84,1.84,0,0,1,1.994-.448,1.774,1.774,0,0,1,1.082,1.736,0.445,0.445,0,0,0,.393.468,8.085,8.085,0,0,0,.921.053,7.847,7.847,0,0,0,.879-0.049,0.445,0.445,0,0,0,.4-0.458,1.778,1.778,0,0,1,1.094-1.706,1.846,1.846,0,0,1,1.981.451,0.447,0.447,0,0,0,.6.05,7.908,7.908,0,0,0,1.294-1.279,0.443,0.443,0,0,0-.048-0.608,1.767,1.767,0,0,1,1.189-3.08l0.1,0a0.445,0.445,0,0,0,.468-0.392A8.018,8.018,0,0,0,527.949,694.112Zm-7.936,3.573a2.669,2.669,0,1,1,2.668-2.668A2.671,2.671,0,0,1,520.013,697.685Z"
      transform="translate(-512 -687)"
    />
  </svg>;



// WEBPACK FOOTER //
// ./app/components/icons/settings-icon.js